import { useEffect, useRef, useState } from 'react'
import { getCanvasOptimalDevicePixelRatio } from '../helpers/canvas'

// Types
interface RenderState {
  state: 'placeholder' | 'ready'
  devicePixelRatio: number
}

export const usePageRenderer = (pageNumber: number) => {
  const [renderState, setRenderState] = useState<RenderState>({
    state: 'placeholder',
    devicePixelRatio: getCanvasOptimalDevicePixelRatio(),
  })

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    // Reset to placeholder when page changes
    setRenderState({
      state: 'placeholder',
      devicePixelRatio: getCanvasOptimalDevicePixelRatio(),
    })

    // Set to ready after short delay to show placeholder briefly
    timeoutRef.current = setTimeout(() => {
      setRenderState({
        state: 'ready',
        devicePixelRatio: getCanvasOptimalDevicePixelRatio(),
      })
    }, 100)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [pageNumber])

  return renderState
}
